import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 my-6" }
const _hoisted_2 = { class: "w-100 d-flex justify-center" }

import DisplayDeliveryPlanInformation from '@/components/DailyReportEdit/Split/DisplayDeliveryPlanInformation.vue';
import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import { formatDateTime } from '@/services/functions';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterModalContent',
  props: {
    deliveryPlan: {},
    splitReturningAndLeavingTime: {}
  },
  setup(__props: any) {

const props = __props;

function changeFormat(dateTime: string | null) {
  return dateTime ? formatDateTime(new Date(dateTime)) : '';
}

return (_ctx: any,_cache: any) => {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h5", null, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.splitConfirmModal.body')), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "mt-2 mb-4 ml-12" }, {
      default: _withCtx(() => [
        _createVNode(DisplayDeliveryPlanInformation, {
          deliveryPlan: props.deliveryPlan
        }, null, 8, ["deliveryPlan"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "text-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "3" }),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createElementVNode("h6", null, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.splitConfirmModal.leavingWarehouse')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createElementVNode("h6", null, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.splitConfirmModal.returningWarehouse')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "text-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "3" }, {
          default: _withCtx(() => [
            _createElementVNode("h6", null, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.splitConfirmModal.orgDeliveryPlan')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(changeFormat(props.deliveryPlan.leaving_warehouse_date_time)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(changeFormat(props.deliveryPlan.returning_warehouse_date_time)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_divider, { class: "my-4" }),
    _createVNode(_component_v_row, { class: "text-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "3" }, {
          default: _withCtx(() => [
            _createElementVNode("h6", null, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.splitConfirmModal.splitDeliveryPlanNo1')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(changeFormat(props.deliveryPlan.leaving_warehouse_date_time)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(changeFormat(props.splitReturningAndLeavingTime.splitReturningTime)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "text-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "3" }, {
          default: _withCtx(() => [
            _createElementVNode("h6", null, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.splitConfirmModal.splitDeliveryPlanNo2')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(changeFormat(props.splitReturningAndLeavingTime.splitLeavingTime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(changeFormat(props.deliveryPlan.returning_warehouse_date_time)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "text-danger text-center"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.dailyReports.splitConfirmModal.announce')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})